'use client';

import { DashboardSnapshotSchema, type DashboardSnapshot } from '@lectura/ts-contracts';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

/**
 * Dashboard pillanatkép.
 * Backend végpont: `GET /api/catalog/dashboard?window_days=N`
 * (catalog-svc aggregálja a publikációs KPI-kat; az analytics-mezők
 * `null` értékűek, amíg az analytics-svc nem áll rendelkezésre.)
 */
export function useDashboardSnapshot(
  windowDays = 30,
  opts: { enabled?: boolean } = {},
) {
  return useQuery<DashboardSnapshot>({
    queryKey: ['dashboard-snapshot', { windowDays }],
    queryFn: () =>
      api(DashboardSnapshotSchema, '/dashboard', {
        query: { window_days: windowDays },
      }),
    refetchInterval: 30_000,
    // Integration-only usernél a hívó letiltja — a végpont 403-at adna.
    enabled: opts.enabled ?? true,
  });
}
